import { useEffect } from 'react';
/**
 * Will invoke the onEnd function, if defined, when the component is unmounted.
 * @param roomId The RoomId for the active room
 * @param onEnd A function to invoke with the RoomId
 */
export function useOnCallEnd(roomId, onEnd) {
    return useEffect(() => {
        return () => {
            if (onEnd) {
                onEnd(roomId);
            }
        };
    }, [onEnd, roomId]);
}
//# sourceMappingURL=use_on_call_end.js.map